import React from 'react'

import Note from '@tonaljs/note'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
	container: {
		fontSize: '1.6rem',
	},
	containerTiny: {
		fontSize: '1rem',
	}
})

const ChordEl = (props: {
	chord: any,
	isDegree?: boolean,
	tiny?: boolean,
  [x:string]: any
}) => {
	const {
		chord,
		isDegree = false,
		tiny = false,
		...rest
	} = props

	const classes = useStyles()

	if (isDegree && chord.degreeName) {

		return (
			<span className={tiny ? classes.containerTiny : classes.container} {...rest}>
				<span style={{ fontWeight: 'normal' }}>{chord.degreeName.split(' ')[0]}</span>
				{chord.degreeName.split(' ').length > 1 && <span style={{ fontSize: 14, verticalAlign: 'top', marginLeft: 3 }}>{chord.degreeName.split(' ')[1]}</span>}
			</span>
		)
	}
	else {
		const { letter, acc, oct } = Note.get(chord.notes[0])
		
		return (
			<span className={tiny ? classes.containerTiny : classes.container} {...rest}>
				<span style={{ fontWeight: 'normal' }}>{letter}</span>
				{acc.split('').map(ac => ac === '#' ? '♯' : ac === 'b' ? '♭' : '').join('')}
				<span style={{ fontSize: 14, verticalAlign: 'top', marginLeft: 3 }}>{chord.currentName.slice(chord.notes[0].length)}</span>
			</span>
		)
	}
}

export default ChordEl
